export const mockVendors = [
  'Delta Electronics',
  'LITE-ON',
  'Alfen BV',
  'Tritium',
  'EV-BOX',
  'SMPCT',
  'PHIHONG',
  'The New Motion BV',
  'CMI',
  'Joint',
  'Atom Power',
  'OCA',
  'ABB',
  'Phihong AX48',
  'TopStar',
  'com.cnchargepoint',
  'IES',
  'EVVendorID',
  'EnelX',
  'telluspower',
  'UnitedChargers',
  'Phihong 48',
  'WWWW',
  'Teltonika_Energy',
  'XCHARGE',
  'Eaton',
  'SWTCH',
  'LGE',
  'guanke',
  'Teltonika Energy',
  'Power Electronics',
  'Zerova AX48',
  'Zerova 120kW',
  'H80',
]

export const mockVendorsObject = {
  deltaElectronics: 'Delta Electronics',
  liteOn: 'LITE-ON',
  alfenBV: 'Alfen BV',
  tritium: 'Tritium',
  evBox: 'EV-BOX',
  smpct: 'SMPCT',
  phihong: 'PHIHONG',
  theNewMotionBV: 'The New Motion BV',
  cmi: 'CMI',
  joint: 'Joint',
  atomPower: 'Atom Power',
  oca: 'OCA',
  abb: 'ABB',
  phihongAX48: 'Phihong AX48',
  topStar: 'TopStar',
  comCnchargepoint: 'com.cnchargepoint',
  ies: 'IES',
  evVendorID: 'EVVendorID',
  enelX: 'EnelX',
  telluspower: 'telluspower',
  unitedChargers: 'UnitedChargers',
  phihong48: 'Phihong 48',
  wwww: 'WWWW',
  teltonikaEnergy: 'Teltonika_Energy',
  xcharge: 'XCHARGE',
  eaton: 'Eaton',
  swtch: 'SWTCH',
  lge: 'LGE',
  guanke: 'guanke',
  powerElectronics: 'Power Electronics',
  zerovaAX48: 'Zerova AX48',
  Zerova120kW: 'Zerova 120kW',
}

export type Vendor = typeof mockVendors[number]
